import React, { useMemo } from 'react';
import useContext from '../../../../../../hooks/useContext';
import Panel from '../../../../../../styled/Panel';
import { CategoryContext } from '../../../Providers/CategoryProvider';
import useFilters from '../../../Providers/useFilters';
import Footer from './Footer';
import FilterList from './FilterList';
import Sort from './Sort';

interface IFilterAndSortPanel {
  onClose: () => void;
  panelFocus: string | undefined;
}

export default function FilterAndSortPanel({ onClose, panelFocus }: IFilterAndSortPanel) {
  const { totalHits } = useContext(CategoryContext);
  const { regularFilters, resetRegularFilters, filters } = useFilters();

  const usedFiltersCount = useMemo(() => Object.keys(filters.regular).length, [filters]);

  return (
    <>
      <Panel
        title="Alla filter"
        onClose={onClose}
        footer={
          <Footer
            usedFiltersCount={usedFiltersCount}
            resetRegularFilters={resetRegularFilters}
            toggleShowPanel={onClose}
            count={totalHits}
          />
        }>
        <Sort panelFocus={panelFocus} />
        <FilterList regularFilters={regularFilters} filters={filters} panelFocus={panelFocus} />
      </Panel>
    </>
  );
}
